<!-- Eng -->
@if (isEng) {
  <div class="common-sub-container theme-userAgreement-bg">
    <div class="common-container" [ngClass]="{ 'common-container--color-settings': colorSettingsMode }">
      <h1 class="common-sub-block__h1 theme-userAgreement__mainTitle">Terms of Use of {{ data?.host }}</h1>
      <h2 class="common-sub-block__h2 theme-userAgreement__subtitle">
        Welcome to the {{ data?.beatmakerName }} website
      </h2>
      <div class="common-sub-block__descr">
        <p>
          {{ data?.beatmakerName | uppercase }} provides this Website and Services (located at
          <a class="terms-block__link theme-userAgreement__link" href="">{{ data?.host }}</a> ) to you subject to the
          notices, terms, and conditions set forth in these terms (the "Terms of Use"). In addition, when you use any of
          our Services, you will be subject to the rules, guidelines, policies, terms, and conditions applicable to such
          service, and they are incorporated into this Terms of Use by this reference.
        </p>
        <p>These Terms of Use are effective as of 01.01.2019</p>
      </div>
      <h3 class="common-sub-block__title terms-block__title">
        Your eligibility for use of the Website is contingent upon meeting the following conditions:
      </h3>
      <ul class="common-sub-block__descr">
        <li>
          1. You use the Website and Services according to these Terms of Use and all applicable laws and regulations
          determined by the state and country of residence
        </li>
        <li>
          2. You provide complete and accurate registration information and maintain accurate registration information
          on the Website
        </li>
        <li>
          3. You agree and understand that we may, at any time, and without prior notice, revoke and/or cancel your
          access if you fail to meet these criteria or violate any portion of these Terms of Use
        </li>
      </ul>
      <h2 class="common-sub-block__h2 theme-userAgreement__subtitle">Use of this Website</h2>
      <h3 class="common-sub-block__title terms-block__title">
        In connection with your use of our Website, you must act responsibly and exercise good judgment. Without
        limiting the foregoing, you will not:
      </h3>
      <ul class="common-sub-block__descr">
        <li>1. Violate any local, state, provincial, national, or other law or regulation, or any order of a court</li>
        <li>
          2. Infringe the rights of any person or entity, including without limitation, their intellectual property,
          privacy, publicity or contractual rights
        </li>
        <li>
          3. Interfere with or damage our Services, including, without limitation, through the use of viruses, cancel
          bots, Trojan horses, harmful code, flood pings, denial-of-service attacks, packet or IP spoofing, forged
          routing or electronic mail address information or similar methods or technology
        </li>
        <li>4. Use automated scripts to collect information or otherwise interact with the Services or the Website</li>
        <li>
          5. Interfere with or damage our Services, including, without limitation, through the use of viruses, cancel
          bots, Trojan horses, harmful code, flood pings, denial-of-service attacks, packet or IP spoofing, forged
          routing or electronic mail address information or similar methods or technology
        </li>
        <li>
          6. Enter into this agreement on behalf of another person or entity without consent or the legal capacity to
          make such agreements as a representative of an organization or entity
        </li>
      </ul>
      <h3 class="common-sub-block__title terms-block__title">Disclaimer of Warranty and Limitation of Liability</h3>
      <p class="common-sub-block__descr">
        The Website is provided "AS IS." appfigures, its suppliers, officers, directors, employees, and agents exclude
        and disclaim all representations and warranties, express or implied, related to this Website or in connection
        with the Services. You exclude Steel Beatz from all liability for damages related to or arising out of the use
        of this Website.
      </p>
      <h3 class="common-sub-block__title terms-block__title">Changes to these Terms of Use</h3>
      <div class="common-sub-block__descr">
        <p>
          Administration retains the right to, at any time, modify or discontinue, any or all parts of the Website
          without notice.
        </p>
        <p>
          Additionally, Administration reserves the right, in its sole discretion, to modify these Terms of Use at any
          time, effective by posting new terms on the Website with the date of modification. You are responsible for
          reading and understanding the terms of this agreement prior to registering with, or using the Service. Your
          use of the Website and/or Services after any such modification has been published constitutes your acceptance
          of the new terms as modified in these Terms of Use.
        </p>
      </div>
      <h3 class="common-sub-block__title terms-block__title">Governing Law</h3>
      <div class="common-sub-block__descr">
        <p>
          These Terms of Use and any dispute or claim arising out of, or related to them, shall be governed by and
          construed in accordance with the internal laws of the Russian Federation without giving effect to any choice
          or conflict of law provision or rule.
        </p>
        <p>
          Any legal suit, action or proceeding arising out of, or related to, these Terms of Use or the Website shall be
          instituted exclusively in the federal courts of Russian Federation.
        </p>
      </div>
    </div>
  </div>
}

<!-- Ru -->
@if (!isEng) {
  <div class="common-sub-container theme-userAgreement-bg">
    <div class="common-container" [ngClass]="{ 'common-container--color-settings': colorSettingsMode }">
      <h1 class="common-sub-block__h1 theme-userAgreement__mainTitle">Пользовательское соглашение</h1>
      <div class="common-sub-block__descr">
        <p>
          Настоящее Пользовательское Соглашение (Далее Соглашение) регулирует отношения между администратором сайта
          <a class="terms-block__link theme-userAgreement__link" href="">{{ data?.host }}</a
          >, которым является {{ data?.fullName }} (далее Администрация) с одной стороны и пользователем сайта с другой.
        </p>
        <p>
          Сайт <a class="terms-block__link theme-userAgreement__link" href="">{{ data?.host }}</a> не является средством
          массовой информации.
        </p>
        <p>Используя сайт, Вы соглашаетесь с условиями данного соглашения.</p>
        <p>
          <strong>Если Вы не согласны с условиями данного соглашения, не используйте сайт </strong>
          <strong
            ><a class="terms-block__link theme-userAgreement__link" href="">{{ data?.host }}</a></strong
          >
        </p>
      </div>
      <h2 class="common-sub-block__h2 theme-userAgreement__subtitle">Предмет соглашения</h2>
      <p class="common-sub-block__descr">
        Администрация безвозмездно предоставляет Пользователю возможность использования Сайта, в том числе приобретения
        Лицензии на Контент с помощью Сайта, а Пользователь при использовании Сайта обязуется соблюдать условия
        Соглашения.
      </p>
      <h2 class="common-sub-block__h2 theme-userAgreement__subtitle">Права и обязанности сторон</h2>
      <h3 class="common-sub-block__title terms-block__title">Администрация имеет право</h3>
      <ul class="common-sub-block__descr">
        <li>1. По своему усмотрению и необходимости создавать, изменять, отменять правила</li>
        <li>2. Ограничивать доступ к любой информации на сайте</li>
        <li>3. Создавать, изменять, удалять информацию</li>
      </ul>
      <h3 class="common-sub-block__title terms-block__title">Пользователь обязуется</h3>
      <ul class="common-sub-block__descr">
        <li>1. Обеспечить достоверность предоставляемой информации</li>
        <li>2. Не нарушать работоспособность сайта</li>
        <li>
          3. Не размещать материалы рекламного, эротического, порнографического или оскорбительного характера, а также
          иную информацию, размещение которой запрещено или противоречит нормам действующего законодательства РФ
        </li>
      </ul>
      <h3 class="common-sub-block__title terms-block__title">Администрация обязуется</h3>
      <ul class="common-sub-block__descr">
        <li>
          поддерживать работоспособность сайта за исключением случаев, когда это невозможно по независящим от
          Администрации причинам.
        </li>
      </ul>
      <h3 class="common-sub-block__title terms-block__title">Ответственность сторон</h3>
      <ul class="common-sub-block__descr">
        <li>
          в случае возникновения форс-мажорной ситуации (боевые действия, чрезвычайное положение, стихийное бедствие и
          т. д.) Администрация не гарантирует сохранность информации, размещённой Пользователем, а также бесперебойную
          работу информационного ресурса
        </li>
      </ul>
      <h3 class="common-sub-block__title terms-block__title">Порядок разрешения споров и урегулирования претензий</h3>
      <ul class="common-sub-block__descr">
        <li>
          Пользователь, считающий, что его права нарушены из-за действий Администрации, направляет последнему по
          электронной почте на адрес:
          <a class="terms-block__link theme-userAgreement__link" href="mailto:{{ data?.adminEmail }}"
            >{{ data?.adminEmail }}
          </a>
          претензию, содержащую суть предъявляемого требования, обоснование его предъявления, а также все данные
          Пользователя.
        </li>
        <li>
          в течение 10 (десяти) рабочих дней со дня получения претензии Администрация обязана изложить свою позицию по
          указанным в ней вопросам и направить свой ответ по адресу электронной почты и почтовому адресу, указанному в
          претензии Пользователем;
        </li>
        <li>
          Администрация не рассматривает анонимные претензии или претензии, не позволяющие идентифицировать Пользователя
          на основе предоставленных им при регистрации данных, или претензии, не содержащие данных, указанных в
          настоящем пункте Соглашения.
        </li>
      </ul>
      <h3 class="common-sub-block__title terms-block__title">Политика возврата</h3>
      <div class="common-sub-block__descr">
        <p>
          После оказания в надлежащем качестве Платной Услуги, деньги, потраченные на ее приобретение, возврату не
          подлежат.
        </p>
        <p>
          В случае, если услуга не была оказана в полной мере или была оказана в ненадлежащем качестве (баланс личного
          кабинета не был пополнен или сумма пополнения отличается от расчётной суммы при оплате заказа), заказчик имеет
          право отказаться от услуги, обратившись по электронной почте, и получить полную компенсацию ее стоимости либо
          аналогичную услугу. Срок рассмотрения претензий и возврата средств — 15 рабочих дней.
        </p>
      </div>
      <ul class="common-sub-block__descr">
        <li>Данное Соглашение вступает в силу при любом использовании данного сайта.</li>
        <li>Соглашение перестает действовать при появлении его новой версии.</li>
        <li>
          Администрация оставляет за собой право в одностороннем порядке изменять данное соглашение по своему
          усмотрению.
        </li>
        <li>
          При изменении соглашения, в некоторых случаях, администрация может оповестить пользователей удобным для нее
          способом.
        </li>
      </ul>
    </div>
  </div>
}
